

	module.exports = {

	methods: {
		trackEvent: function(event) {
			if(typeof window.gaSentEvents == 'undefined')
				window.gaSentEvents = {};

			if(!window.gaSentEvents[event]){
				ga('send', 'event', 'Picture wall', event);
				ga('clientTracker.send', 'event', 'Picture wall', event);

				var countryCode = window.vueInstance.$t('countryCode').toLowerCase();
				dataLayer.push({
					'event': 'Picture Wall',
					'category': 'Picture Wall',
					'action': event,
					'label': '',
					'value': ''
				});

				var page =  "/picture-wall-" + window.replaceAll(event, ' ' , '-') + ".html";

				ga('set', 'page', page);
				ga('clientTracker.set', 'page', page);
				ga('send', 'pageview');
				ga('clientTracker.send', 'pageview');
				window.gaSentEvents[event] = true;
			}
			
		}
	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/events.js